<table mat-table [dataSource]="billingData" matSort (matSortChange)="sortChange($event)">
  @for (column of columns; track column; let i = $index) {
    <ng-container matColumnDef="{{column}}">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{headings[i]}} </th>
      <td mat-cell *matCellDef="let element">
        @if (column === 'organisationName' || column === 'runId' || column === 'error' || column === 'currencyCode') {
          {{element[column]}}
          }@else if (column === 'paid' || column === 'createdDate') {
          {{element[column] | date}}
          }@else if (column === 'status') {
          {{getBillingStatus(element[column])}}
          }@else if (column === 'nodes' || column === 'projects' || column === 'users') {
          {{element[column].number | number}}
          }@else {
          {{element[column] | currency: element.currencyCode||'NZD': 'symbol-narrow': '1.0-0'}}
        }
      </td>
    </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let element; columns: columns;"></tr>
</table>
